import { SET_LOCALE, SET_TENANT } from '@/store/mutation.types';

export default {
    state: () => ({
        locale: null,
        tenant: null
    }),

    actions: {
        select: ({ commit }, { tenant, locale }) => {
            commit(SET_TENANT, tenant);
            commit(SET_LOCALE, locale);
        }
    },

    mutations: {
        [SET_LOCALE]: (state, locale) => {
            state.locale = locale;
        },

        [SET_TENANT]: (state, tenant) => {
            state.tenant = tenant;
        }
    }
};
